import { type QueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api-client.js';

interface AdminSession { authenticated: boolean }

export const adminSessionQuery = {
  queryKey: ['session'],
  queryFn: async (): Promise<AdminSession> => {
    try { return await api<AdminSession>('/api/session', { signal: AbortSignal.timeout(5_000) }); }
    catch (error) {
      // A rejected session must replace previously authenticated cached data.
      if (error instanceof Error && 'status' in error && error.status === 401) return { authenticated: false };
      throw error;
    }
  },
  networkMode: 'always' as const,
  retry: false,
  staleTime: 30_000,
  refetchOnWindowFocus: false,
};

export async function logoutAdminSession(client: QueryClient): Promise<void> {
  await api('/api/session', { method: 'DELETE' });
  // An older session request must not restore authentication after logout.
  await client.cancelQueries({ queryKey: adminSessionQuery.queryKey, exact: true });
  client.setQueryData<AdminSession>(adminSessionQuery.queryKey, { authenticated: false });
}
